// <div data-controller="admin--categories--feed">
//
// </div>
import { Controller } from "stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "container", "loading", "stat" ];
  static classes = [ "" ]
  static values = {
    loading: Boolean,
    finished: Boolean,
    firstNextUrl: String
  };

  initialize() {
    this.nextUrl = this.firstNextUrlValue;
  }

  nextFeed() {
    if (this.containerTarget.innerHTML.trim() === "") {
      return;
    }

    this.loadingValue = true;
    this.loadingTarget.classList.remove("hidden");

    api.get(`${this.nextUrl}`, null, {
      'Accept': 'application/html',
      'Content-Type': 'application/html',
    }).then((res) => {
      const responseDoc = new DOMParser().parseFromString(res.data, "text/html");
      const preRenderedFeeds = responseDoc.getElementById("preRenderedFeeds");
      const stat = responseDoc.getElementById("stat");

      if (preRenderedFeeds) {
        const renderedFeeds = preRenderedFeeds.innerHTML;
        if (renderedFeeds.trim() !== "") {
          this.containerTarget.insertAdjacentHTML('beforeend', renderedFeeds);
        }

        this.containerTarget.insertAdjacentHTML('beforeend', stat.innerHTML);
        this.nextUrl = responseDoc.getElementById("nextUrl").value;

        this.loadingValue = false;
        this.finishedValue = renderedFeeds.trim() === "";
        this.loadingTarget.classList.add("hidden");
      }

      if (this.finishedValue) {
        this.containerTarget.insertAdjacentHTML("beforeend", "<p class='text-center w-full font-bold'>끝</p>");
      }
    });
  }

  connect() {
    // preRender 된 첫 페이지 stat 출력
    this.containerTarget.insertAdjacentHTML('beforeend', document.getElementById("stat").innerHTML);

    this.nextFeed()
  }

  onScroll(e) {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 3000) {
      if (!this.loadingValue && !this.finishedValue) {
        this.nextFeed();
      }
    }
  }

  disconnect() {

  }
}